import { QueryKeyEnum } from '@hotjar/global-filters';
import type { Recording } from '@hotjar/webapp/features/Playbacks/types';

export const SimilarRecordingsFilterOptions: { [key: string]: keyof Recording } = {
  USER_ID: QueryKeyEnum.visitor_uuid,
  COUNTRY: QueryKeyEnum.country_code,
  BROWSER: QueryKeyEnum.browser,
  DEVICE: QueryKeyEnum.device,
  OS: QueryKeyEnum.os,
  REFERRER: QueryKeyEnum.referrer,
};
